import { takeEvery, call, put, all } from 'redux-saga/effects';
import { GET_CERTIFICATES } from 'store/actionTypes';
import { GetCollectionDocs } from 'store/services/collection';
import { SetDocService, GetDocService, RemoveDocService } from 'store/services/document';
import { FileUploadService, FileRemoveService } from 'store/services/file';
import { message } from 'antd';

// watchers

export function* GetCertificatesWatcher() {
    yield takeEvery(GET_CERTIFICATES.WATCH, GetCertificatesWorker);
}


function* GetCertificatesWorker({ payload }) {
    try {
        yield put({ type: GET_CERTIFICATES.LOAD });
        const response = yield call(GetCollectionDocs, payload)
        yield put({ type: GET_CERTIFICATES.SUCCESS, payload: response });
    } catch (e) {
        message.error(e.message);
        yield put({ type: GET_CERTIFICATES.FAIL, payload: e.message });
    }
}